import React, { Suspense, lazy } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { Provider } from 'react-redux';

import { DOCUMENT_RESULTS_PAGE, NOT_FOUND_PAGE } from './routes';
import WithAuth from './components/with-auth';
import Error from './components/error';
import GetLang from './components/get-lang';
import { store } from 'store';
import { ToastContainer } from 'react-toastify';
import { ReactComponent as CloseIcon } from './icons/close.svg';

const ErrorPage = lazy(() => import('./pages/error'));
const ResultsPage = lazy(() => import('./pages/results'));
const AuthPage = lazy(() => import('./pages/auth'));

declare global {
  interface Window {
    APP_BASE_URL: string;
    SSO_ENDPOINT: string;
    SSO_CODE_CHALLENGE: string;
    SSO_CLIENT_ID: string;
    SSO_STATE: string;
    PQA_TRAINING_GUIDE_URL: string;
  }
}

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <Route path="/" component={GetLang} />
        <Switch>
          <Route path="/" exact>
            <Suspense fallback={<div />}>
              <AuthPage />
            </Suspense>
          </Route>
          <Route path={DOCUMENT_RESULTS_PAGE}>
            <WithAuth>
              <Suspense fallback={<div />}>
                <ResultsPage />
              </Suspense>
            </WithAuth>
          </Route>
          <Suspense fallback={<div />}>
            <Route path="/:errorCode(415)" component={ErrorPage} exact />
          </Suspense>
          <Route path={NOT_FOUND_PAGE} component={Error} />
          <Route path="*">
            <Redirect to="/404" />
          </Route>
        </Switch>
      </Router>
      <ToastContainer
        position={'top-right'}
        autoClose={false}
        closeOnClick={true}
        draggable={true}
        closeButton={() => <CloseIcon />}
      />
    </Provider>
  );
}
